<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               @row-del="rowDel"
               v-model="form"
               ref="crud"
               :permission="permissionList"
               @row-update="rowUpdate"
               @row-save="rowSave"
               :before-open="beforeOpen"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
               
                
      <template slot="payTimeSearch">
        <el-date-picker
          style="width:100%"
          clearable
          @blur="payTimeChange"
          v-model="payTime"
          type="datetimerange"
          :default-time="['00:00:00','23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>



                
      <template slot="feeStartTimeSearch">
        <el-date-picker
          style="width:100%"
          clearable
          @blur="feeStartTimeChange"
          v-model="feeStartTime"
          type="datetimerange"
          :default-time="['00:00:00','23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>

      
      <template slot="feeEndTimeSearch">
        <el-date-picker
          style="width:100%"
          clearable
          @blur="feeEndTimeChange"
          v-model="feeEndTime"
          type="datetimerange"
          :default-time="['00:00:00','23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>



    </avue-crud>
  </basic-container>
</template>

<script>
  import {getList
   } from "./parkvehicle";
  //  src\api\v4ward\park\vehiclev3\parkvehicle.js
  import {mapGetters} from "vuex";
  import dayjs from "dayjs";

  export default {
    
  props:{
      spaceId:{
        type:'string',
        default:'',
      },
      carManageType:{
        type:'string',
        default:'',
      },
      carId:{
        type:'string',
        default:'',
      },
                    
  },
    data() {
      return {
        
        spaceStatusData:[
           
            {
                dictKey:'1',
                dictValue:'已出售',
            },
            {
                dictKey:'2',
                dictValue:'空闲',
            },
        ],
        isDoubleData:[
            {
                dictKey:'0',
                dictValue:'否',
            },
            {
                dictKey:'1',
                dictValue:'是',
            },
            
        ],
        form: {},
        query: {
          // carManageType:3
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        payTime:["",""],
        feeStartTime:["",""],
        feeEndTime:["",""],
        // payTime:"",
        selectionList: [],
        option: {
          menu:false,
          height: 'auto',
          calcHeight: 90,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          indexLabel: '序号',
          addBtn:false,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          column: [
            
            {
              label: "车牌号",
              prop: "plateNumber",
              search: true,
              searchOrder:6,
              rules: [{
                required: true,
                message: "请输入车牌号",
                trigger: "blur"
              }]
            },
            {
              label: "车主姓名",
              prop: "personName",
              search: true,
              searchOrder:6,
              rules: [{
                required: true,
                message: "请输入车主姓名",
                trigger: "blur"
              }]
            },
            {
              label: "车主电话",
              prop: "personPhone",
              search: true,
              searchOrder:6,
              rules: [{
                required: true,
                message: "请输入车主电话",
                trigger: "blur"
              }]
            },
            {
              label: "车位编号",
              prop: "parkingSpaceNames",
              // search: true,
              // searchOrder:6,
              rules: [{
                required: true,
                message: "请输入车位编号",
                trigger: "blur"
              }]
            },
            
            
            
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.client_add),
          viewBtn: this.vaildData(this.permission.client_view),
          delBtn: this.vaildData(this.permission.client_delete),
          editBtn: this.vaildData(this.permission.client_edit)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    mounted(){
      
      this.$nextTick(() => {
                      this.option.height = this.bodyHeight - 343
              // this.reWrite = true;
              console.log(this.bodyHeight);
              setTimeout(()=>{
              console.log(this.$refs.crud)
              console.log(this.$refs.crud.$children[1].$children.length);
              let arrLength = this.$refs.crud.$children[1].$children.length;
              console.log(this.$refs.crud.$children[1].$children[arrLength-2].$el);
              this.$refs.crud.$children[1].$children[arrLength-2].$el.addEventListener("click", ()=>{
                // console.log(1212121)
                console.log("this.option.height=====>",this.option.height);
                    if(this.option.height == this.bodyHeight - 284){
                      this.option.height = this.bodyHeight - 343
                    }else{
                      this.option.height = this.bodyHeight - 284;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
            });
    },
    methods: {
      searchReset() {
        // this.query = {carManageType:3};
        this.payTime = ['',''];
        this.feeStartTime = ['',''];
        this.feeEndTime = ['',''];
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
        console.log("selectionChange=============>",list);
        // if(list.length>1){
        // }
        let ids = this.getSelectedIds(list);
        let names = this.getSelectedNames(list);
        this.$emit('getCarOwner',[ids,names]);
      },
      getSelectedIds(list){
        let ids = [];
        list.forEach(ele => {
          ids.push(ele.id)
        });
        return ids.join(',');
      },
      getSelectedNames(list){
        let ids = [];
        list.forEach(ele => {
          ids.push(ele.plateNumber)
        });
        return ids.join(',');
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        console.log('monthcar-log==============>',);
        this.loading = true;
        let date = {};
        console.log(this.feeStartTime,this.feeEndTime,this.payTime);
        if(this.feeStartTime[0]){
          date.feeStartTimeBegin = dayjs(this.feeStartTime[0]).format('YYYY-MM-DD');
          date.feeStartTimeEnd = dayjs(this.feeStartTime[1]).format('YYYY-MM-DD');
        }
        if(this.feeEndTime[0]){
          date.feeEndTimeBegin = dayjs(this.feeEndTime[0]).format('YYYY-MM-DD');
          date.feeEndTimeEnd = dayjs(this.feeEndTime[1]).format('YYYY-MM-DD');
        }
        if(this.payTime[0]){
          date.payTimeBegin = dayjs(this.payTime[0]).format('YYYY-MM-DD HH:mm:ss');
          date.payTimeEnd = dayjs(this.payTime[1]).format('YYYY-MM-DD HH:mm:ss');
        }
        console.log();
        getList(Object.assign(params, {...{carId:this.carId,isMainCar:1,spaceId:this.spaceId,current: page.currentPage,size: page.pageSize,carManageType:this.carManageType}, ...this.query,...date})).then(res => {
          console.log("getList=======monthcar-log=======>",res.data);
          const data = res.data;
          this.page.total = data.total;
          this.data = data.records;
          this.data.forEach((ele)=>{
            ele.payTime = dayjs(ele.payTime).format('YYYY-MM-DD HH:mm:ss');
            ele.feeStartTime = dayjs(ele.feeStartTime).format('YYYY-MM-DD');
            ele.feeEndTime = dayjs(ele.feeEndTime).format('YYYY-MM-DD');
          })
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
